import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "./pages/Auth/Login";
import { refreshAPI } from "./APIConfig/Interceptor";
import { useCallback, useEffect, useState } from "react";
import AuthRoute from "./AuthRoute";
import TwoFactorAuth from "./pages/Auth/TwoFactorAuth";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";
import SignUp from "./pages/Auth/SignUp";
import ProtectedRoute from "./ProtectedRoute";
import Vendors from "./pages/Vendors/Vendors";
import { ThemeProvider } from "./lib/ThemeProvider";
import { Toaster } from "./components/ui/toaster";
import AccountSetting from "./pages/AccountSettings/AccountSetting";
import TwoFactorRegister from "./pages/Auth/TwoFactorRegister/TwoFactorRegister";
import { TooltipProvider } from "./components/ui/tooltip";
import ChartOfAccounts from "./pages/ChartOfAccounts/ChartOfAccounts";
import EmailVerification from "./pages/Auth/EmailVerification";
import TrustDashboard from "./pages/Dashboard/TrustDashboard";
import Contacts from "./pages/Contacts/Contacts";
import Assets from "./pages/Assets/Assets";
import SubAssets from "./pages/SubAssets/SubAssets";
import Cashbook from "./pages/Reports/Cashbook";
import GeneralLedger from "./pages/Reports/GeneralLedger";
import TrialBalance from "./pages/Reports/TrialBalance";
import Banking from "./pages/Banking/Banking";
import { AppearanceProvider } from "./lib/context/AppearanceContext";
import Jobs from "./pages/Jobs/Jobs";
import Tasks from "./pages/Tasks/Tasks";
import Payments from "./pages/Payments/Payments";
import Suppliers from "./pages/Suppliers/Suppliers";
import Beneficiarys from "./pages/Beneficiarys/Beneficiarys";
import Receipts from "./pages/Receipts/Receipts";
// import FinancialReports from "./pages/Reports/Financial Reports/FinancialReports";
import JournalEntries from "./pages/JournalEntries/JournalEntries";
import Contracts from "./pages/Contracts/Contracts";
import Trusts from "./pages/Trust/Trusts";
import { OrganizationProvider } from "./lib/context/OrganisationContext";
import Users from "./pages/Organizations/Users/Users";
import Offices from "./pages/Organizations/Offices/Offices";
import SupportTicket from "./pages/Admin/SupportTicket/SupportTicket";
import Subscription from "./pages/Subscription/Subscription";
import GeneralSetting from "./pages/GeneralSettings/GeneralSetting";
import AdminRoute from "./AdminRoute";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminUsers from "./pages/Admin/Users/Users";
import AdminRoles from "./pages/Admin/Role/Roles";
import UserPermission from "./pages/UserPermission/UserPermission";
import PageNotFound from "./PageNotFound";
import StatmentReports from "./pages/Reports/Statements/StatmentReports";
// import Documents from "./pages/Documents/Documents";
// import UploadDocuments from "./pages/Documents/UploadDocuments";
import AcceptUser from "./pages/Organizations/Users/AcceptUser";
import RejectUser from "./pages/Organizations/Users/RejectUser";
import { UserProvider } from "./lib/context/UserContext";
import TrustGeneralSetting from "./pages/TrustGeneralSettings/TrustGeneralSetting";
import ABATabs from "./pages/ABATransactions/ABATabs";
import { getCookie } from "./lib/Misc";
import GlobalRedirectHandler from "./pages/GlobalOrgRedirectHandler";
import RegisteredUsers from "./pages/Admin/Registered Users/RegisteredUsers";
import TwoFactorEmailChange from "./pages/Auth/TwoFactorEmailChange/TwoFactorEmailChange";
import AMLCTFTabs from "./pages/AML-CTF/AMLCTFTabs";
import AdminAMLCTFTabs from "./pages/Admin/AML-CTF/AdminAMLCTFTabs";
import ModuleNamings from "./pages/Admin/Module Naming/ModuleNamings";
import Discounts from "./pages/DiscountCodes/Discounts";
import Invoicing from "./pages/Invoicing/Invoicing";
import ProcessingFees from "./pages/ProcessingFeeCodes/ProcessingFees";
import States from "./pages/Admin/States/States";
import Suburbs from "./pages/Admin/Suburbs/Suburbs";
import OpeningBalances from "./pages/OpeningBalance/OpeningBalances";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [tfa, setTfa] = useState(0);
  const halfHour = 30 * 60000;

  const authenticate = useCallback(
    (token, email, tfaCheck = 0, refreshToken) => {
      localStorage.setItem("ts-auth-tfa", tfaCheck);

      setIsAuthenticated(true);
      setTfa(tfa);

      localStorage.setItem("ts-auth-token", token);
      localStorage.setItem("ts-refresh-token", refreshToken);
      setInterval(() => {
        refreshAPI();
      }, [halfHour]);
      localStorage.setItem("ts-auth-email", email);
    },
    [tfa, halfHour],
  );

  useEffect(() => {
    const lsToken = localStorage.getItem("ts-auth-token");
    const email = localStorage.getItem("ts-auth-email");
    const tfaCheck = localStorage.getItem("ts-auth-tfa");
    const reToken = localStorage.getItem("ts-refresh-token");

    if (lsToken || reToken) {
      authenticate(lsToken, email, tfaCheck, reToken);
    }
  }, [authenticate]);

  useEffect(() => {
  if (typeof window === "undefined") return;

  const { hostname, pathname, search, hash } = window.location;
  
  if (hostname === "beta.trustsoft.com.au") {
    window.location.replace(
      `https://app.trustsoft.com.au${pathname}${search}${hash}`
    );
  }
}, []);
  return (
    <>
      {/* Start:To set the Theme in the portal - Start*/}
      <ThemeProvider
        attribute="class"
        defaultTheme={
          localStorage.getItem("theme")
            ? localStorage.getItem("light")
            : getCookie("theme")
              ? getCookie("theme")
              : "light"
        }
        enableSystem
        disableTransitionOnChange
      >
        {/* Start: To set the Color Theme in the portal */}
        <AppearanceProvider>
          {/* To set the Tooltip in the portal */}
          <TooltipProvider>
            {/* Start: To set the Organization Data in the portal */}
            <OrganizationProvider>
              {/* Start: To set the User Data in the portal */}
              <UserProvider>
                {/* Start: Routing in the port */}

                {/* Auth Route is for the Auth Pages */}
                {/* Protected Route is for the logged in check of the user */}
                {/* Admin Route is for the Admin User */}
                <BrowserRouter
                  future={{
                    v7_relativeSplatPath: true,
                    v7_startTransition: true,
                  }}
                >
                  <GlobalRedirectHandler />
                  <Routes>
                    {/* Start: Authentication Pages Routes */}
                    <>
                      <Route
                        exact
                        path="/"
                        element={
                          <Login
                            authenticate={authenticate}
                            isAuthenticated={isAuthenticated}
                            tfa={tfa}
                          />
                        }
                      />
                      <Route
                        exact
                        path="/2fa"
                        element={
                          <AuthRoute component={TwoFactorAuth}></AuthRoute>
                        }
                      />
                      <Route
                        exact
                        path="/2fa/register"
                        element={
                          <AuthRoute component={TwoFactorRegister}></AuthRoute>
                        }
                      />
                      <Route
                        exact
                        path="/2fa/change"
                        element={
                          <AuthRoute
                            component={TwoFactorEmailChange}
                          ></AuthRoute>
                        }
                      />
                      <Route
                        exact
                        path="/forgot-password"
                        element={<ForgotPassword />}
                      />
                      <Route
                        exact
                        path="/reset-password"
                        element={<ResetPassword />}
                      />
                      <Route exact path="/signup" element={<SignUp />} />
                      <Route
                        exact
                        path="/email-verification"
                        element={<EmailVerification />}
                      />

                      <Route
                        exact
                        path="/users/accept"
                        element={<AcceptUser />}
                      />

                      <Route
                        exact
                        path="/users/reject"
                        element={<RejectUser />}
                      />
                    </>
                    {/* End: Authentication Pages Routes */}

                    {/* Start: Portal Pages Routes */}
                    <>
                      <Route
                        path="/trusts"
                        element={
                          <ProtectedRoute
                            notSubscription={true}
                            component={Trusts}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trusts/:trust_id/vendors"
                        element={
                          <ProtectedRoute
                            notSubscription={true}
                            component={Vendors}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="/vendors"
                        element={
                          <ProtectedRoute
                            notSubscription={true}
                            AMLCTFPage={true}
                            component={() => <Vendors org={true} />}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="/account-settings"
                        element={
                          <ProtectedRoute
                            component={AccountSetting}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/chart-of-accounts"
                        element={
                          <ProtectedRoute
                            component={ChartOfAccounts}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/dashboard"
                        element={
                          <ProtectedRoute
                            component={TrustDashboard}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/contacts"
                        element={
                          <ProtectedRoute
                            component={Contacts}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="/contacts"
                        element={
                          <ProtectedRoute
                            notSubscription={true}
                            AMLCTFPage={true}
                            component={() => <Contacts org={true} />}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/assets"
                        element={
                          <ProtectedRoute
                            component={Assets}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/sub-assets"
                        element={
                          <ProtectedRoute
                            component={SubAssets}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/contracts"
                        element={
                          <ProtectedRoute
                            component={Contracts}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trusts/:trust_id/cashbook-report"
                        element={
                          <ProtectedRoute
                            component={Cashbook}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="cashbook-report"
                        element={
                          <ProtectedRoute
                            component={() => <Cashbook org={true} />}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trusts/:trust_id/general-ledger-report"
                        element={
                          <ProtectedRoute
                            component={GeneralLedger}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="general-ledger-report"
                        element={
                          <ProtectedRoute
                            component={() => <GeneralLedger org={true} />}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trusts/:trust_id/statement-report"
                        element={
                          <ProtectedRoute
                            component={StatmentReports}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="statement-report"
                        element={
                          <ProtectedRoute
                            component={() => <StatmentReports org={true} />}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trusts/:trust_id/trial-balance-report"
                        element={
                          <ProtectedRoute
                            component={TrialBalance}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trial-balance-report"
                        element={
                          <ProtectedRoute
                            component={() => <TrialBalance org={true} />}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      {/* <Route
                        path="trusts/:trust_id/financial-report"
                        element={
                          <ProtectedRoute
                            component={FinancialReports}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="financial-report"
                        element={
                          <ProtectedRoute
                            component={() => <FinancialReports org={true} />}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      /> */}

                      <Route
                        path="trusts/:trust_id/banking"
                        element={
                          <ProtectedRoute
                            component={Banking}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trusts/:trust_id/opening-balances"
                        element={
                          <ProtectedRoute
                            component={OpeningBalances}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="banking"
                        element={
                          <ProtectedRoute
                            component={() => <Banking org={true} />}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="users"
                        element={
                          <ProtectedRoute
                            component={() => <Users org={true} />}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="offices"
                        element={
                          <ProtectedRoute
                            component={() => <Offices org={true} />}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="aml-ctf"
                        element={
                          <ProtectedRoute
                            AMLCTFPage={true}
                            component={() => <AMLCTFTabs org={true} />}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trusts/:trust_id/jobs"
                        element={
                          <ProtectedRoute
                            component={Jobs}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/tasks"
                        element={
                          <ProtectedRoute
                            component={Tasks}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/discount-codes"
                        element={
                          <ProtectedRoute
                            component={Discounts}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/processing-fees"
                        element={
                          <ProtectedRoute
                            component={ProcessingFees}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/payments"
                        element={
                          <ProtectedRoute
                            component={Payments}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/abas"
                        element={
                          <ProtectedRoute
                            component={ABATabs}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/suppliers"
                        element={
                          <ProtectedRoute
                            component={Suppliers}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/beneficiaries"
                        element={
                          <ProtectedRoute
                            component={Beneficiarys}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/receipts"
                        element={
                          <ProtectedRoute
                            component={Receipts}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/journal-entries"
                        element={
                          <ProtectedRoute
                            component={JournalEntries}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trusts/:trust_id/invoices"
                        element={
                          <ProtectedRoute
                            component={Invoicing}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      {/* <Route
                        path="trusts/:trust_id/documents"
                        element={
                          <ProtectedRoute
                            component={Documents}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="trusts/:trust_id/upload-document"
                        element={
                          <ProtectedRoute
                            component={UploadDocuments}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      /> */}

                      <Route
                        path="trusts/:trust_id/trust-general-settings"
                        element={
                          <ProtectedRoute
                            component={TrustGeneralSetting}
                            notSubscription={true}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="support-tickets"
                        element={
                          <ProtectedRoute
                            component={() => <SupportTicket org={true} />}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="trusts/:trust_id/trust-support-tickets"
                        element={
                          <ProtectedRoute
                            component={() => <SupportTicket />}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="subscription"
                        element={
                          <ProtectedRoute
                            component={() => <Subscription org={true} />}
                          ></ProtectedRoute>
                        }
                      />
                      <Route
                        path="general-settings"
                        element={
                          <ProtectedRoute
                            component={() => <GeneralSetting org={true} />}
                          ></ProtectedRoute>
                        }
                      />

                      <Route
                        path="user-permission"
                        element={
                          <ProtectedRoute
                            component={() => <UserPermission org={true} />}
                          ></ProtectedRoute>
                        }
                      />
                    </>
                    {/* End: Portal Pages Routes */}

                    {/* Start: Admin Pages Routes */}
                    <>
                      <Route
                        path="/admin-dashboard"
                        element={
                          <AdminRoute component={AdminDashboard}></AdminRoute>
                        }
                      />
                      <Route
                        path="/admin-users"
                        element={
                          <AdminRoute component={AdminUsers}></AdminRoute>
                        }
                      />
                      <Route
                        path="/admin-roles"
                        element={
                          <AdminRoute component={AdminRoles}></AdminRoute>
                        }
                      />
                      <Route
                        path="/registered-users"
                        element={
                          <AdminRoute component={RegisteredUsers}></AdminRoute>
                        }
                      />
                      <Route
                        path="/admin/support-tickets"
                        element={
                          <AdminRoute component={SupportTicket}></AdminRoute>
                        }
                      />
                      <Route
                        path="/admin/aml-ctf"
                        element={
                          <AdminRoute component={AdminAMLCTFTabs}></AdminRoute>
                        }
                      />
                      <Route
                        path="/admin/module-namings"
                        element={
                          <AdminRoute component={ModuleNamings}></AdminRoute>
                        }
                      />

                      <Route
                        path="/admin/states"
                        element={<AdminRoute component={States}></AdminRoute>}
                      />
                      <Route
                        path="/admin/suburbs"
                        element={<AdminRoute component={Suburbs}></AdminRoute>}
                      />
                    </>
                    {/* End: Admin Pages Routes */}

                    {/* Default Route Page */}
                    <Route path="*" element={<PageNotFound />} />
                  </Routes>
                </BrowserRouter>

                {/* End: Routing in the port */}
                <Toaster />
              </UserProvider>
              {/* End: To set the User Data in the portal */}
            </OrganizationProvider>
            {/* End: To set the Organization Data in the portal */}
          </TooltipProvider>
          {/* End: To set the Tooltip in the portal */}
        </AppearanceProvider>
        {/* End: To set the Color Theme in the portal */}
      </ThemeProvider>
      {/* End: To set the Theme in the portal*/}
    </>
  );
}

export default App;
